import { Component } from '@verndale/core';
import axios from 'axios';

import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import { isPhoneOnly } from '../utils/breakpoints';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $productsContainer: this.el._$(
        '.preview-product-compare__products-container'
      ),
      $compareProducts: this.el._$$('.preview-product-compare__product'),
      $minimizeButton: this.el._$('.preview-product-compare__btn-minimize'),
      $compareButton: this.el._$('.preview-product-compare__btn-compare')
    };
    this.getProductsUrl = this.dom.$el.getAttribute('data-get-products-url');
    this.removeProductUrl = this.dom.$el.getAttribute(
      'data-remove-product-url'
    );
    this.loadProducts();

    if (isPhoneOnly()) this.handleMinimize();
  } //setupDefaults

  addListeners() {
    const { $minimizeButton, $compareButton } = this.dom;
    document._on(constEvent.COMPARE_PREVIEW, this.openModal.bind(this));
    document._on(constEvent.ADD_TO_COMPARE_LIST, this.loadProducts.bind(this));
    $minimizeButton?._on('click', this.handleMinimize.bind(this));
    $compareButton?._on('click', this.handleCompare.bind(this));
  } //addListeners

  handleCompare() {
    dispatchGenericEvent(constEvent.COMPARE_PRODUCTS);
  }

  handleMinimize() {
    const { $el } = this.dom;
    if ($el.classList.contains('minimized')) {
      $el.classList.remove('minimized');
    } else {
      $el.classList.add('minimized');
    }
  }

  loadProducts() {
    const { $el, $productsContainer, $compareProducts, $compareButton } =
      this.dom;
    const removeLabel = $el.getAttribute('data-remove-label');
    let compareProductsData =
      localStorage.getItem(constEvent.COMPARE_LOCAL_STORAGE_NAME) || null;

    $productsContainer.classList.add('loading');

    if (compareProductsData && JSON.parse(compareProductsData).length > 0) {
      $el.classList.add('active');
      compareProductsData = JSON.parse(compareProductsData);
    } else {
      $el.classList.remove('active');
      compareProductsData = [];
    }

    $el._$('.preview-product-compare__title span').innerHTML =
      compareProductsData.length;

    $compareProducts.forEach(($product, index) => {
      let productHtml = '';
      if (compareProductsData[index]) {
        $product.classList.remove('placeholder');
        productHtml = `
          <h4>${compareProductsData[index].number}</h4>
          <div class="product-info">
            <button type="button" class="preview-product-compare__remove-button" aria-label="${removeLabel}" data-product-id="${compareProductsData[index].number}"></button>
            <p>${compareProductsData[index].name}</p>
          </div>
        `;
      } else {
        $product.classList.add('placeholder');
        productHtml = `
          <h4>${$product.getAttribute('data-placeholder-title')}</h4>
          <span class="product-placeholder"></span>
        `;
      }
      $product.innerHTML = productHtml;
    });

    $productsContainer
      ._$$('.preview-product-compare__remove-button')
      ?._on('click', this.removeProduct.bind(this));
    if (compareProductsData.length > 1) {
      $compareButton.disabled = false;
    } else {
      $compareButton.disabled = true;
    }

    $productsContainer.classList.remove('loading');
  } //loadProducts

  openModal(e) {
    const { $el } = this.dom;
    $el.classList.remove('hidden');
  } //openModal

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  } //post

  removeProduct(e) {
    e.preventDefault();
    dispatchGenericEvent(constEvent.REMOVED_COMPARE_PRODUCT);
    const productId = e.currentTarget.getAttribute('data-product-id');
    const compareProducts = JSON.parse(
      localStorage.getItem(constEvent.COMPARE_LOCAL_STORAGE_NAME)
    );
    compareProducts.forEach((item, index) => {
      if (item.number === productId) {
        compareProducts.splice(index, 1);
        const $checkbox = document._$(
          `input[name="compare"][data-product-id="${productId}"]`
        );
        if ($checkbox) {
          $checkbox.checked = false;
        }
      }
    });
    localStorage.setItem(
      constEvent.COMPARE_LOCAL_STORAGE_NAME,
      JSON.stringify(compareProducts)
    );
    this.loadProducts();
  }
}

export default Module;
